/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@tcp/core/src/components/common/molecules/Modal';
import { routerPush, getDateObject } from '@tcp/core/src/utils';
import { isOldItem } from '@tcp/core/src/components/features/account/CustomerHelp/util/utility';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import {
  CUSTOMER_HELP_GA,
  CUSTOMER_HELP_ROUTES,
  REASON_CODES,
} from '@tcp/core/src/components/features/account/CustomerHelp/CustomerHelp.constants';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import { getAPIConfig, getIconPath } from '@tcp/core/src/utils/utils';
import ResendOrderConfirmation from '../../ResendOrderConfirmation/container/ResendOrderConfirmation.container';
import ResendOrderConfirmationSaga from '../../ResendOrderConfirmation/container/ResendOrderConfirmation.saga';
import { helpWithOrderStyle, modalstyles } from '../styles/HelpWithOrder.style';
import pushEventToAdobeAnalytics from '../../../../../adobeAnalytics/adobe.utils';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import HelpMenuLabels, {
  CHECKOUT_ORDERCONFIRMATION,
  GLOBAL_HELPCENTER,
} from '../../HelpMenu/container/HelpMenu.label';
import { ORDER_TYPE } from '../../../../features/CnC/Checkout/Checkout.constants';

const MoreHelpCtas = (ctaProps) => {
  const { to, title, imgUrl, target, noLink, handleLinkClick, asPath, trackAnalyticsClick } =
    ctaProps;
  const handleClick = handleLinkClick
    ? (event) => {
        event.preventDefault();
        setTimeout(() => {
          trackAnalyticsClick({
            orderHelpLocation: CUSTOMER_HELP_GA.HELP_DRAWER_TRACK.CD126,
          });
          pushEventToAdobeAnalytics(
            'location_of_self_help',
            CUSTOMER_HELP_GA.HELP_DRAWER_TRACK.CD126
          );
          handleLinkClick();
        }, 0);
      }
    : null;
  return (
    <div className="more-help-inner-container">
      <Anchor
        to={to}
        title={title}
        asPath={asPath}
        noLink={noLink}
        target={target}
        className="more-help-with-order-ctas"
        handleLinkClick={handleClick}
      >
        <DamImage
          aria-hidden="true"
          className="more-help-with-order-image"
          imgConfigs={['w_100', 'w_100', 'w_100']}
          width="100%"
          imgData={{
            url: imgUrl,
            alt: title,
          }}
        />
        <BodyCopy
          fontSize="fs14"
          className="more-help-with-order-text"
          fontFamily="secondary"
          textAlign="left"
        >
          {title}
        </BodyCopy>
      </Anchor>
    </div>
  );
};

const checkReturnEligiblefromOrderStatus = (refundEligibleShipmentStatus) => {
  const { returnInitiated, returnCompleted, deliveredItemShipment } =
    refundEligibleShipmentStatus || {};
  const isReturnInitiated = returnInitiated.length > 0;
  const isDeliveredItemShipment = deliveredItemShipment.length > 0;
  const isReturnCompleted = returnCompleted.length > 0;
  if (isReturnCompleted && !isDeliveredItemShipment && !isReturnInitiated) return false;
  return isReturnInitiated || isDeliveredItemShipment || isReturnCompleted;
};

const getAsPath = (baseUrl, fromOrderList, fromTrackOrder) => {
  if (fromOrderList) {
    return `${baseUrl}?fromOrderList`;
  }
  if (fromTrackOrder) {
    return `${baseUrl}?track-order`;
  }
  return baseUrl;
};

const HelpWithOrderModal = (props) => {
  const {
    className,
    isHelpWithOrderOpen,
    setHelpWithOrderOpen,
    setOrderResendModalOpen,
    orderId,
    isCSHEnabled,
    trackAnalyticsClick,
    cshReturnItemOlderDays,
    orderDateWithoutFormatting,
    refundEligibleShipmentStatus,
    isAddAltPickupPersonEnabled,
    altPickupPersonLimit,
    altPickupPersonInvaildOrderStatus,
    orderDetailsData,
    altPickUpPersons: altPickUpPersonsFromList,
    fromOrderList,
    isEcomOrder: isEcomOrderFromOrderList,
    pickUpStore: pickUpStoreOrderList,
    orderFullStatus,
    ...otherProps
  } = props;
  const helpMenuLabels = {
    ...getLabelFromCopyOrFromTranslation(CHECKOUT_ORDERCONFIRMATION, HelpMenuLabels),
    ...getLabelFromCopyOrFromTranslation(GLOBAL_HELPCENTER, HelpMenuLabels),
  };

  const { orderType, checkout, orderStatus } = orderDetailsData || {};
  const { pickUpStore } = checkout || {};
  const getIsEcomOrder = () => {
    return (
      orderType === ORDER_TYPE.PURE_ECOM ||
      orderType === ORDER_TYPE.ECOM_MIX ||
      orderType === 'ECOM'
    );
  };

  const isEcomOrder = fromOrderList ? isEcomOrderFromOrderList : getIsEcomOrder();
  const dynamicHelpMenuLabels = getDynamicLabelValues('dynamic.checkout_d');
  const {
    lbl_more_help_return_policy_text: returnPolicyText,
    lbl_help_with_order_modal_open: orderHelpCTA,
    lbl_order_status_help_text: orderStatusHelpText,
    lbl_modal_initiate_return: initiateReturnText,
  } = helpMenuLabels || {};

  const { snjMinOrderNo } = getAPIConfig();
  let atLeastOneItemDelivered = false;
  if (refundEligibleShipmentStatus)
    atLeastOneItemDelivered = checkReturnEligiblefromOrderStatus(refundEligibleShipmentStatus);
  const returnEligible =
    atLeastOneItemDelivered &&
    !isOldItem(getDateObject(orderDateWithoutFormatting), cshReturnItemOlderDays);
  const invalidPickupStatus = altPickupPersonInvaildOrderStatus
    ?.split(',')
    ?.map((str) => str?.toLowerCase());
  const orderStat = orderStatus || orderFullStatus;
  const hideLink = invalidPickupStatus?.includes(orderStat?.toLowerCase());
  const pickUpPerson = fromOrderList ? altPickUpPersonsFromList : pickUpStore?.altPickUpPersons;
  const addPickPersonLabel = getDynamicLabelValues('dynamic.account_d.lbl_addPickup');
  const baseUrl = `${CUSTOMER_HELP_ROUTES.ADD_PICKUP_PERSON.asPath}/${orderId}`;
  let fromTrackOrder;
  if (typeof window !== 'undefined') {
    fromTrackOrder = window?.location?.href?.split('/')?.includes('track-order');
  }
  const asPathForAddPickUp = getAsPath(baseUrl, fromOrderList, fromTrackOrder);
  const addPickUpUrls = {
    to: `${CUSTOMER_HELP_ROUTES.ADD_PICKUP_PERSON.to}&orderId=${orderId}`,
    asPath: asPathForAddPickUp,
  };
  return (
    <Modal
      isOpen={isHelpWithOrderOpen}
      colSet={{ small: 6, medium: 6, large: 8 }}
      className={`${className} help-with-order-modal`}
      headingAlign="center"
      heading={orderHelpCTA}
      heightConfig={{ height: 'auto', maxHeight: '100%' }}
      overlayClassName="TCPModal__Overlay help-with-order-overlay"
      onRequestClose={() => setHelpWithOrderOpen(false)}
      closeIconDataLocator="help-with-order-modal"
      fixedWidth
      aria={{
        describedby: 'more-help-with-order',
      }}
      inheritedStyles={modalstyles}
    >
      {isCSHEnabled && returnEligible && (
        <MoreHelpCtas
          title={initiateReturnText}
          imgUrl={dynamicHelpMenuLabels.lbl_initiate_return_img}
          handleLinkClick={() =>
            routerPush(
              `${CUSTOMER_HELP_ROUTES.TELL_US_MORE.to}&orderId=${orderId}&reasonCode=${REASON_CODES.INITIATE_RETURN}`,
              `${CUSTOMER_HELP_ROUTES.TELL_US_MORE.asPath}/${orderId}/${REASON_CODES.INITIATE_RETURN}`
            )
          }
          noLink
          trackAnalyticsClick={trackAnalyticsClick}
        />
      )}

      {orderId < snjMinOrderNo && (
        <MoreHelpCtas
          handleLinkClick={() => setOrderResendModalOpen(true)}
          title={renderLabel(
            helpMenuLabels[`lbl_more_help_resend-confirm-text`],
            'lbl_more_help_resend-confirm-text'
          )}
          imgUrl={getDynamicLabelValues('dynamic.checkout_d.lbl_more_help_resend-confirm-img')}
          noLink
          trackAnalyticsClick={trackAnalyticsClick}
        />
      )}

      <MoreHelpCtas
        to={renderLabel(
          dynamicHelpMenuLabels.lbl_more_help_return_policy_url,
          'lbl_more_help_return_policy_url'
        )}
        title={returnPolicyText}
        imgUrl={renderLabel(
          dynamicHelpMenuLabels.lbl_more_help_return_policy_img,
          'lbl_more_help_return_policy_img'
        )}
        target="_blank"
        trackAnalyticsClick={trackAnalyticsClick}
      />

      {isCSHEnabled ? (
        <>
          <MoreHelpCtas
            title={orderStatusHelpText}
            imgUrl={renderLabel(
              dynamicHelpMenuLabels.lbl_order_status_help_img,
              'lbl_order_status_help_img'
            )}
            handleLinkClick={() =>
              routerPush(
                `${CUSTOMER_HELP_ROUTES.TELL_US_MORE.to}&orderId=${orderId}`,
                `${CUSTOMER_HELP_ROUTES.TELL_US_MORE.asPath}/${orderId}`
              )
            }
            noLink
            trackAnalyticsClick={trackAnalyticsClick}
          />
          {!hideLink &&
            isAddAltPickupPersonEnabled &&
            !isEcomOrder &&
            (pickUpPerson?.length < altPickupPersonLimit ? (
              <MoreHelpCtas
                to={addPickUpUrls?.to}
                asPath={addPickUpUrls?.asPath}
                title={addPickPersonLabel}
                imgUrl={getIconPath('order-pickup')}
              />
            ) : (
              <div className="more-help-inner-container">
                <div className="more-help-with-order-ctas">
                  <DamImage
                    aria-hidden="true"
                    className="more-help-with-order-image disable-image"
                    imgConfigs={['w_100', 'w_100', 'w_100']}
                    imgData={{
                      url: getIconPath('order-pickup'),
                      alt: addPickPersonLabel,
                    }}
                  />
                  <div>
                    <BodyCopy
                      fontSize="fs14"
                      className="more-help-with-order-text link-disable"
                      fontFamily="secondary"
                      textAlign="left"
                    >
                      {addPickPersonLabel}
                    </BodyCopy>
                  </div>
                </div>
                <div className="max-pickup-error">
                  <BodyCopy
                    fontSize="fs12"
                    className=""
                    fontFamily="secondary"
                    fontWeight="extrabold"
                    textAlign="left"
                    color="red.500"
                    component="span"
                  >
                    {`Note: `}
                  </BodyCopy>
                  <BodyCopy
                    fontSize="fs12"
                    component="span"
                    className=""
                    fontFamily="secondary"
                    textAlign="left"
                    color="red.500"
                  >
                    {getDynamicLabelValues('dynamic.account_d.lbl_addPickup_csh_max_person_error')}
                  </BodyCopy>
                </div>
              </div>
            ))}
        </>
      ) : null}
      <ResendOrderConfirmation {...otherProps} orderId={orderId} />
    </Modal>
  );
};

HelpWithOrderModal.propTypes = {
  className: PropTypes.string,
  isHelpWithOrderOpen: PropTypes.bool.isRequired,
  setHelpWithOrderOpen: PropTypes.func.isRequired,
  setOrderResendModalOpen: PropTypes.func.isRequired,
  orderAssistanceText: PropTypes.string,
  orderId: PropTypes.string.isRequired,
  isCSHEnabled: PropTypes.bool,
  trackAnalyticsClick: PropTypes.func,
};

HelpWithOrderModal.defaultProps = {
  className: '',
  orderAssistanceText: '',
  isCSHEnabled: false,
  trackAnalyticsClick: () => {},
};

const withSaga = withDynamicSaga({
  key: 'OrderResendConfirmation',
  saga: ResendOrderConfirmationSaga,
});

export default withSaga(withStyles(HelpWithOrderModal, helpWithOrderStyle));
export { HelpWithOrderModal as HelpWithOrderModalVanilla };
